module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/nmb4tp/tc-custom/9781488001765.jpg?1721404212755",
      "alt": "This image is the cover for the book Pregnancy Scandal, Love and Lipstick"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Pregnancy Scandal, Love and Lipstick\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("They married for the sake of the baby. Will they stay together for love? ")]), _c('br'), _c('br'), _vm._v("Widowed power player Phillip Edgewood's political ambitions demand he have a wifethey don't demand he love her. It's a good thing, too, because his heart belongs to the perfect wife he lost. But finding a woman who will say \"I do\" to his deal proves difficult. Until he meets Alexandra Meerthe sexy CFO he can't resist. She doesn't believe in happily-ever-after, even after their amazing night together. And now she's pregnant with his child! A marriage of convenience should end the scandal and solve all their problemsas long as they don't fall in love\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Kat Cantrell\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Harlequin\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5610da35","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0